import { Feedback } from '@shared/constants/feedback';
import PhotoSlider from '@components/molecules/FeedbackSlider';
import useDevice from '@hooks/useDevice';

type FeedbackMobileProps = {
  content: Feedback[];
};

function FeedbackMobile({ content }: FeedbackMobileProps) {
  const { isDesktop } = useDevice();

  if (isDesktop) return null;

  return <PhotoSlider content={content} />;
}

export default FeedbackMobile;
